export default __webpack_public_path__ + "static/media/Octicons-mark-github-1.f2a4bd36.svg";